export default Object.freeze({
  NORMAL: 'Normalna',
  PALETTE: 'Paleta',
  CONTAINER: 'Kontener',
});
